import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export const exportToPDF = async (
  containerRef,
  dateRange,
  dataMode,
  chartRefs
) => {
  const pdf = new jsPDF("p", "mm", "a4");
  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();
  const margin = 10;
  const usableWidth = pageWidth - 2 * margin;
  let yPosition = margin;

  const originalWidth = containerRef.current.style.width;
  containerRef.current.style.width = "1200px";

  pdf.setFontSize(16);
  pdf.text("Booking Analytics Report", pageWidth / 2, yPosition, {
    align: "center",
  });
  yPosition += 10;
  pdf.setFontSize(9);
  pdf.text(
    `Date Range: ${
      dateRange[0] ? dateRange[0].toLocaleDateString("vi-VN") : "N/A"
    } to ${dateRange[1] ? dateRange[1].toLocaleDateString("vi-VN") : "N/A"}`,
    pageWidth / 2,
    yPosition,
    { align: "center" }
  );
  yPosition += 8;
  pdf.text(`Data Mode: ${dataMode}`, pageWidth / 2, yPosition, {
    align: "center",
  });
  yPosition += 10;

  const summaryRef = chartRefs.summary;
  if (summaryRef.current) {
    const canvas = await html2canvas(summaryRef.current, {
      scale: 2,
      backgroundColor: "#ffffff",
    });
    const imgData = canvas.toDataURL("image/jpeg", 1.0);
    const imgWidth = usableWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    if (yPosition + imgHeight + margin > pageHeight) {
      pdf.addPage();
      yPosition = margin;
    }

    pdf.setFontSize(12);
    pdf.text("Booking Summary", margin, yPosition);
    yPosition += 5;
    pdf.addImage(
      imgData,
      "JPEG",
      margin,
      yPosition,
      imgWidth,
      imgHeight,
      undefined,
      "FAST"
    );
    yPosition += imgHeight + 10;
  }

  const chartKeys = [
    {
      key: "bookings",
      title:
        dataMode === "Booked Data"
          ? "Bookings Over Time (Booked Date)"
          : "Bookings Over Time (Check-in Date)",
    },
    {
      key: "roomNights",
      title:
        dataMode === "Booked Data"
          ? "Room Nights Over Time (Booked Date)"
          : "Room Nights Over Time (Check-in Date)",
    },
    {
      key: "revenue",
      title:
        dataMode === "Booked Data"
          ? "Revenue Over Time (Booked Date)"
          : "Revenue Over Time (Check-in Date)",
    },
    {
      key: "adr",
      title:
        dataMode === "Booked Data"
          ? "ADR Over Time (Booked Date)"
          : "ADR Over Time (Check-in Date)",
    },
    {
      key: "los",
      title:
        dataMode === "Booked Data"
          ? "LOS Over Time (Booked Date)"
          : "LOS Over Time (Check-in Date)",
    },
    {
      key: "leadTime",
      title:
        dataMode === "Booked Data"
          ? "Lead Time Over Time (Booked Date)"
          : "Lead Time Over Time (Check-in Date)",
    },
    {
      key: "roomType",
      title:
        dataMode === "Booked Data"
          ? "Most Booked Room Types (Booked Date)"
          : "Most Booked Room Types (Check-in Date)",
    },
    {
      key: "promotion",
      title:
        dataMode === "Booked Data"
          ? "Most Used Promotions (Booked Date)"
          : "Most Used Promotions (Check-in Date)",
    },
    {
      key: "ratePlan",
      title:
        dataMode === "Booked Data"
          ? "Most Used Rate Plans (Booked Date)"
          : "Most Used Rate Plans (Check-in Date)",
    },
    {
      key: "paymentMethod",
      title:
        dataMode === "Booked Data"
          ? "Most Used Payment Methods (Booked Date)"
          : "Most Used Payment Methods (Check-in Date)",
    },
    { key: "bookedNationality", title: "Booked Nationalities" },
    { key: "cancelledNationality", title: "Cancelled Nationalities" },
  ];

  for (const chart of chartKeys) {
    const ref = chartRefs[chart.key];
    if (ref.current) {
      const canvas = await html2canvas(ref.current, {
        scale: 2,
        backgroundColor: "#ffffff",
      });
      const imgData = canvas.toDataURL("image/jpeg", 1.0);
      const imgWidth = usableWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      if (yPosition + imgHeight + margin > pageHeight) {
        pdf.addPage();
        yPosition = margin;
      }

      pdf.setFontSize(12);
      pdf.text(chart.title, margin, yPosition);
      yPosition += 5;
      pdf.addImage(
        imgData,
        "JPEG",
        margin,
        yPosition,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      yPosition += imgHeight + 10;
    }
  }

  containerRef.current.style.width = originalWidth;

  pdf.save(
    `Booking_Analytics_${
      dateRange[0]?.toLocaleDateString("vi-VN") || "N/A"
    }_to_${dateRange[1]?.toLocaleDateString("vi-VN") || "N/A"}.pdf`
  );
};
